import AutocompleteMultiple from './AutocompleteMultiple.jsx'

export default AutocompleteMultiple
